
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator";

interface reservaData {
  rut: string;
  dia: string | null;
  hora: string | null;
  nombre: string;
  mesa: string | null;
  estado: number;
  observacion: string | null;
}

interface dataIngreso {
  rut_apoderado: string;
  nombre_apoderado: string;
}

interface selectType {
  value: number | null;
  label: string | null;
}

@Component({
  components: {
    ResultadoComponent: () =>
      import(
        /* webpackPrefetch: true */ "@/components/Formulario2026/ResultadoFinalComponent.vue"
      )
  }
})
export default class FormularioResultadoComponent extends Mixins(
  FormValidator
) {
  private formattedRut = "";
  private formattedRutMenor = "";
  private validRut = true;
  private errorType = "";
  private step = "LANDING";
  private apiData: any = null;

  private dataForm: dataIngreso = {
    rut_apoderado: "",
    nombre_apoderado: ""
  };

  private aListaAlumnos: Array<reservaData> = [];

  @Watch("formattedRut")
  private formatRut(newValue: string) {
    newValue = newValue
      .replace(/\./g, "")
      .replace(/-/g, "")
      .toUpperCase();
    this.dataForm.rut_apoderado = this.rutSanitize(newValue);
    if (newValue.length > 5) {
      const rut = newValue
        .substring(0, newValue.length - 1)
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
      const dv = newValue.substring(newValue.length - 1);
      this.formattedRut = `${rut}-${dv}`;
    } else {
      this.formattedRut = newValue
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
        .toUpperCase();
    }
  }

  private mounted() {}

  private enviarForm() {
    if (this.dataForm.rut_apoderado.replace(/\s/g, "") == "") {
      Notify.create({
        color: "negative",
        message: "Debe completar el Rut del adulto responsable",
        icon: "report_problem",
        position: "top",
        timeout: 2500
      });
      return;
    }

    if (!this.validateRut(this.dataForm.rut_apoderado)) {
      Notify.create({
        color: "negative",
        message: "Debe ingresar un Rut válido",
        icon: "report_problem",
        position: "top",
        timeout: 2500
      });
      return;
    }
    const data = new FormData();
    for (const prop in this.dataForm) {
      if (this.dataForm.hasOwnProperty(prop)) {
        // @ts-ignore
        if (this.dataForm[prop] || this.dataForm[prop] === 0) {
          // @ts-ignore
          data.append(prop, this.dataForm[prop]);
        }
      }
    }
    this.$q.loading.show({
      delay: 100 // ms
    });

    this.$axios
      .get("/resultados/2026/rut?rut=" + this.dataForm.rut_apoderado)
      .then((res: any) => {
        this.$q.loading.hide();
        this.dataForm.nombre_apoderado = res.data.nombre;
        this.aListaAlumnos = res.data.data;
        console.log(this.aListaAlumnos);
        this.errorType = "SUCCESS";
      })
      .catch((err: any) => {
        if (err.response.data.message == "NO_REGISTRADO") {
          this.$q.loading.hide();
          // Error
          this.errorType = "OTRO";
          Notify.create({
            color: "negative",
            message:
              "El Rut ingresado no tiene postulaciones para este beneficio",
            icon: "report_problem",
            position: "top",
            timeout: 4000
          });
          return;
        } else {
          this.$q.loading.hide();
          // Error
          this.errorType = "OTRO";
          Notify.create({
            color: "negative",
            message: "Ha ocurrido un error, intentelo nuevamente",
            icon: "report_problem",
            position: "top",
            timeout: 4000
          });
          return;
        }
      });
  }

  private rutSanitize(rut: string) {
    const temp = rut.replace(/\./g, "").replace(/-/g, "");
    const rutNumber = temp.substring(0, temp.length - 1);
    const dv = temp.substring(temp.length - 1);
    return `${rutNumber}-${dv}`;
  }
  private validEmail(email: any) {
    // eslint-disable-next-line
    let emailRegex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRegex.test(email) === true) {
      return true;
    } else {
      return false;
    }
  }
  public validateRut(newValue: string) {
    var texto = newValue;
    var tmpstr = "";
    for (let i = 0; i < texto.length; i++)
      if (
        texto.charAt(i) != " " &&
        texto.charAt(i) != "." &&
        texto.charAt(i) != "-"
      )
        tmpstr = tmpstr + texto.charAt(i);
    texto = tmpstr;
    var largo = texto.length;
    if (largo < 2) {
      this.validRut = false;
      return false;
    }
    for (let i = 0; i < largo; i++) {
      if (
        texto.charAt(i) != "0" &&
        texto.charAt(i) != "1" &&
        texto.charAt(i) != "2" &&
        texto.charAt(i) != "3" &&
        texto.charAt(i) != "4" &&
        texto.charAt(i) != "5" &&
        texto.charAt(i) != "6" &&
        texto.charAt(i) != "7" &&
        texto.charAt(i) != "8" &&
        texto.charAt(i) != "9" &&
        texto.charAt(i) != "k" &&
        texto.charAt(i) != "K"
      ) {
        this.validRut = false;
        return false;
      }
    }
    var invertido = "";
    for (let i = largo - 1, j = 0; i >= 0; i--, j++)
      invertido = invertido + texto.charAt(i);
    var dtexto = "";
    dtexto = dtexto + invertido.charAt(0);
    dtexto = dtexto + "-";
    var cnt = 0;
    for (let i = 1, j = 2; i < largo; i++, j++) {
      //alert("i=[" + i + "] j=[" + j +"]" );
      if (cnt == 3) {
        dtexto = dtexto + ".";
        j++;
        dtexto = dtexto + invertido.charAt(i);
        cnt = 1;
      } else {
        dtexto = dtexto + invertido.charAt(i);
        cnt++;
      }
    }
    invertido = "";
    for (let i = dtexto.length - 1, j = 0; i >= 0; i--, j++)
      invertido = invertido + dtexto.charAt(i);

    if (this.revisarDigito2(texto)) {
      this.validRut = true;
      return true;
    }
    this.validRut = false;
    return false;
  }
  public revisarDigito(dvr: string) {
    var dv = dvr + "";
    if (
      dv != "0" &&
      dv != "1" &&
      dv != "2" &&
      dv != "3" &&
      dv != "4" &&
      dv != "5" &&
      dv != "6" &&
      dv != "7" &&
      dv != "8" &&
      dv != "9" &&
      dv != "k" &&
      dv != "K"
    ) {
      return false;
    }
    return true;
  }
  public revisarDigito2(crut: string) {
    var largo = crut.length;
    if (largo < 2) {
      return false;
    }
    if (largo > 2) var rut = crut.substring(0, largo - 1);
    else rut = crut.charAt(0);
    var dv = crut.charAt(largo - 1);
    this.revisarDigito(dv);
    if (rut == null || dv == null) return 0;
    var dvr = "0";
    var suma = 0;
    var mul = 2;
    for (let i = rut.length - 1; i >= 0; i--) {
      suma = suma + parseInt(rut.charAt(i), 10) * mul;
      if (mul == 7) mul = 2;
      else mul++;
    }
    var res = suma % 11;
    if (res == 1) dvr = "k";
    else if (res == 0) dvr = "0";
    else {
      var dvi = 11 - res;
      dvr = dvi + "";
    }
    if (dvr != dv.toLowerCase()) {
      return false;
    }
    return true;
  }
  private checkFecha(d: any) {
    if (Object.prototype.toString.call(d) === "[object Date]") {
      // it is a date
      if (isNaN(d.getTime())) {
        // d.valueOf() could also work
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
}
